
<footer class="footer" id="vvdo-footer">
  <!--  -->
  <!-- add behind ID below if needed  -->
  <div *ngIf="appUrlState === '/'" id="covid-banner" class="covid-info">
    <a href="https://travel.gov.gr/#/" target="_blank" rel="noopener">
      <p>Get the latest on our COVID-19 response</p>
    </a>
  </div>
  <app-back-to-top></app-back-to-top>
  <app-cookies></app-cookies>
  <div id="modal-background" [ngClass]="{'active' : isLoading()}"></div>
  <div id="modal-content" [ngClass]="{'active' : isLoading()}">
    <div class="loader"></div>
  </div>​

  <div class="footer-container flex jc-sb" [ngStyle]="isMobile()?{'display':'none'}:{}">
    <img src="../../../../assets/img/vervendo_logo-combination_vertical.svg" alt="Vervendo Logo">
    <div class="footer-links flex-col  gap-02">
      <h5>Hosting</h5>
      <a routerLink="villa-collection">Villa Collection</a>
      <a (click)="angulartics2Track('ExtranetLoginFooter')" href="https://admin.vervendo.com/extranet.html"
        target="_blank" rel="noopener noreferrer">Extranet Login</a>
      <a (click)="goToPropertyReg(); angulartics2Track('PropertyRegistrationFooter')" target="_blank"
        rel="noopener noreferrer">
        List your Property</a>
    </div>

    <div class="footer-links flex-col gap-02">
      <h5>Travelling</h5>
      <a routerLink="/my-dashboard/my-requests" title="My Requests">Requests</a>
      <a routerLink="/my-dashboard/my-bookings" title="My Bookings">Bookings</a>
      <a routerLink="/my-dashboard/my-settings" title="My Settings">Settings</a>

      <a *ngIf="!isLoggedIn()" class="nav__button" data-toggle="modal" data-backdrop="false"
        (click)="goToLoginPage('signup')" placement="bottom">Register</a>
      <a *ngIf="!isLoggedIn()" class="nav__button" data-toggle="modal" data-backdrop="false"
        (click)="goToLoginPage('login')" placement="bottom">Login</a>
    </div>
    <div class="footer-links flex-col gap-02">
      <h5>Contact</h5>
      <address>
        <a class="address-text footer-links" href="mailto:info@vervendo.com">info@vervendo.com</a>
      </address>
      <a href="tel:+30694-047-0700">694-047-0700</a>
    </div>

  </div>

  <div class="footer-contact jc-sb">
    <div class="flex ai-c gap-02">
      <span>© 2021 Vervendo · Based in Crete</span>
      <span>·</span>
      <a href="#howItWorks">How it Works</a>
      <span>·</span>
      <a routerLink="about-us">About Us</a>
    </div>
    <div class="flex ai-c">
      <a rel="noopener" title="Link to Vervendo's Facebook Page" href="https://www.facebook.com/vervendocom"
        (click)="angulartics2Track('FooterSocialFB')" target="_blank">
        <svg class="footer-social" aria-hidden="true" focusable="false" data-prefix="fab" data-icon="facebook"
          role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path
            d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z">
          </path>
        </svg>
      </a>
      <a rel="noopener" title="Link to Vervendo's Instagram Page" href="https://instagram.com/vervendocom"
        (click)="angulartics2Track('FooterSocialINSTAGRAM')" target="_blank">
        <svg class="footer-social" aria-hidden="true" focusable="false" data-prefix="fab" data-icon="instagram"
          role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
          <path
            d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z">
          </path>
        </svg>
      </a>
    </div>
  </div>
</footer>